// Best-effort field-path resolution for dashboards whose exact response shape
// (aging_matrix / performance_matrix / status_funnel / trend_analysis) is
// inferred, not confirmed against the live API — see Analytics Phase 2 plan.
// pick() tries each candidate path in order and returns the first defined
// value instead of crashing or silently rendering 0 on a wrong guess.
const getPath = (obj, path) =>
  path.split(".").reduce((acc, key) => (acc && typeof acc === "object" ? acc[key] : undefined), obj);

export const pick = (obj, paths, fallback = undefined) => {
  for (const path of paths) {
    const value = getPath(obj, path);
    if (value !== undefined && value !== null) return value;
  }
  return fallback;
};

export const humanize = (key) =>
  String(key)
    .replace(/_/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());

// Derives McTable columns generically from the first row's own keys, so a
// drill-down table is always correct regardless of exact field names.
export const genericColumns = (rows, { hide = [] } = {}) => {
  if (!rows || rows.length === 0) return [];
  return Object.keys(rows[0])
    .filter((key) => !hide.includes(key))
    .map((key) => ({ id: key, label: humanize(key) }));
};

const ACTOR_KEYS = [
  "actor", "actor_name",
  "approver_name", "approver",
  "po_creator_name", "po_creator",
  "owner_name", "owner",
  "assigned_to", "assignee", "user", "name",
];

// Label for a performance-matrix row (approver / PO creator / invoice owner).
// Tries the known field names first, then falls back to any string field whose
// key looks like a person (…name, …email, …creator, …owner…), so a backend
// rename doesn't turn every bar into "Unknown".
export const pickActorLabel = (row, fallback = "Unknown") => {
  const known = pick(row, ACTOR_KEYS);
  if (known !== undefined && String(known).trim() !== "") return String(known);
  const key = Object.keys(row || {}).find(
    (k) => /name|email|approver|creator|owner|assign|actor|user/i.test(k) && typeof row[k] === "string" && row[k].trim() !== ""
  );
  return key ? row[key] : fallback;
};
